import Vue from 'vue'
import App from './App.vue'
import { store } from './store/index';
import router from './router';
import util from './util';

import './assets/styles/index.css';

Vue.config.productionTip = false

Vue.filter('toYMD', val => val instanceof Date ? util.dateToYMD(val) : '' );

new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')